import { Component, ElementRef, ViewChild } from "@angular/core";
import { trigger, transition, animate, style } from "@angular/animations";
import { APIService } from "../../APIService";
import { Subject, Subscription } from "rxjs";
import { NgxSpinnerService } from "ngx-bootstrap-spinner";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LayoutService } from "src/app/shared/services/layout.service";
import { ToastrService } from "ngx-toastr";
import { OrderPipe } from "ngx-order-pipe";
import { environment } from "../../../../environments/environment";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  animations: [
    trigger("slideInOut", [
      transition(":enter", [
        style({ transform: "translateY(100%)" }),
        animate("200ms ease-in", style({ transform: "translateY(0%)" })),
      ]),
    ]),
  ],
})
export class DashboardComponent {
  viewMode = "tab1";
  apiUrl = environment.serverIP;
  @ViewChild("fileInput") fileInput: ElementRef;
  subscriptions: Subscription[] = [];
  logData = [];
  searchTerm = "";
  jobCreated = "";
  fileError = [];
  pageControl: number = 1;
  attachmentForm: FormGroup;
  fileValid = false;
  uploading = false;
  downloading = false;
  dataErrorMessage = false;
  loading = true;
  order: string = "";
  reverse = false;
  sortedCollection = [];

  files = [];
  isDragged = false;
  searchInput = new Subject();
  searchValue: string;

  score = 75;
  is_exact = false;
  result_count = 1;
  constructor(
    private _apiService: APIService,
    private orderPipe: OrderPipe,
    private spinner: NgxSpinnerService,
    private formbuilder: FormBuilder
  ) {
    this.subscriptions.push(
      this._apiService.fileErrors.subscribe((errorMessage) => {
        this.fileError = errorMessage;
      })
    );

    this.subscriptions.push(
      this._apiService.dataError.subscribe((message) => {
        this.dataErrorMessage = message;
      })
    );

    let temp: FormGroup[] = [];
    this.attachmentForm = this.formbuilder.group({
      attachments: this.formbuilder.array(temp),
    });

    // this.searchInput.pipe(debounceTime(500)).subscribe(() => {
    //   this.SearchLog();
    // });
  }

  ngOnInit() {
    this.getAllLogData();
  }

  getAllLogData() {
    this.spinner.show();
    this.loading = true;
    this.subscriptions.push(
      this._apiService.getAllLogData().subscribe(
        (response) => {
          if (response.status == "ok") {
            this.logData = response.result.data;
            this.logData.sort((a, b) => {
              return a["requested_on"] - b["requested_on"];
            }); //sorted by ID.

            this.logData.reverse(); // for latest show

            this._apiService.dataError.next(false);
            this.loading = false;
            this.spinner.hide();
          } else {
            this.loading = false;

            this.spinner.hide();
            this._apiService.dataError.next(true);
            this.logData = [];
          }
        },
        (err) => {
          this.loading = false;

          this.dataErrorMessage = true;
          this.spinner.hide();
        }
      )
    );
  }

  // SearchLog() {
  //   if (this.searchTerm) {
  //     this._apiService.searchLogData(this.searchTerm).subscribe((res) => {
  //       // console.log("Job created", res);
  //       this.jobCreated = "Job created successfully!"
  //       setTimeout(() => {
  //         this.searchTerm = '';
  //         this.jobCreated = '';
  //       }, 3000);
  //     }, (err) => {
  //       // this.uploading = false;
  //     });
  //   }
  // }

  TrimFileName(file) {
    let fileName = "";
    let temp = file.split("/");

    if (temp) fileName = temp[temp.length - 1];
    else fileName = file;
    return fileName;
  }

  FileLink() {
    return this.apiUrl + "media/files/sample/sample.tsv";
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  truncateString(str, n) {
    if (str.length > n) {
      return str.substring(0, n) + "...";
    } else {
      return str;
    }
  }

  setOrder(value: string) {
    // console.log(this.pageControl);
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.order = value;
    this.sortedCollection = this.orderPipe.transform(this.logData, this.order);
    // console.log(this.sortedCollection);

    this.logData = this.sortedCollection;
  }

  QueryManipulation(params) {
    return params.replace(/['']+/g, "");
  }

  getFromSessionStorage(item) {
    return sessionStorage.getItem(item);
  }
  FileSizeConverter(bytes) {
    const sizes = ["B", "KB", "MB", "GB", "TB"];

    if (bytes == 0) {
      return "n/a";
    }

    const i = Math.floor(Math.log(bytes) / Math.log(1024));

    if (i == 0) {
      return bytes + " " + sizes[i];
    }

    return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
  }

  TabView(mode) {
    switch (mode) {
      case "tab1":
        this.viewMode = "tab1";
        // this.uploading = false;
        this._apiService.fileErrors.next([]);

        break;
      case "tab2":
        this.viewMode = "tab2";
        break;
    }
  }

  Upload() {
    if (this.score && (this.score < 75 || this.score > 100)) {
      if (
        this._apiService.fileErrors
          .getValue()
          .indexOf("Score value must be within 75 to 100") == -1
      ) {
        this._apiService.fileErrors
          .getValue()
          .push("Result count value must be > 0");
      }
      this._apiService.fileErrors.next(this._apiService.fileErrors.getValue());
    }
    if (this.result_count == 0) {
      if (
        this._apiService.fileErrors
          .getValue()
          .indexOf("Invalid Result Count value!") == -1
      ) {
        this._apiService.fileErrors
          .getValue()
          .push("Invalid Result Count value!");
      }
      this._apiService.fileErrors.next(this._apiService.fileErrors.getValue());
    } else {
      if (
        this.attachmentForm.value.attachments[0] &&
        this.files &&
        this.files.length &&
        this.score &&
        this.result_count &&
        !this.uploading
      ) {
        this.spinner.show();
        this.uploading = true;
        this._apiService
          .uploadTSV(
            this.attachmentForm.value.attachments[0].file,
            this.attachmentForm.value.attachments[0].actualFile,
            {
              result_count: this.result_count,
              score: this.score,
              is_exact: this.is_exact,
            }
          )
          .subscribe(
            (res) => {
              if (res.status == "ok") {
                this.spinner.hide();
                let fileName = this.TrimFileName(
                  this.attachmentForm.value.attachments[0].actualFile.name
                );
                let obj = {
                  id: res.result.data.jobs[0].job,
                  created_on: new Date().toISOString(),
                  requested_by_username: res.result.data.jobs[0].requested_by,
                  upload_file_name: fileName,
                  status: "pending",
                  name: fileName,
                };
                this.logData.unshift(obj);
                this.jobCreated =
                  "Job created successfully with Id: " +
                  res.result.data.jobs[0].job;
                this.uploading = false;
                this.files = [];

                let attachments = this.attachmentForm.get(
                  "attachments"
                ) as FormArray;
                attachments.removeAt(0);
                setTimeout(() => {
                  this.jobCreated = "";
                }, 5000);
              } else {
                this.spinner.hide();
                this.uploading = false;
                if (
                  this._apiService.fileErrors
                    .getValue()
                    .indexOf("Uploading failed, Please try again!") == -1
                ) {
                  this._apiService.fileErrors
                    .getValue()
                    .push("Uploading failed, Please try again!");
                }
                this._apiService.fileErrors.next(
                  this._apiService.fileErrors.getValue()
                );
              }
            },
            (err) => {
              this.spinner.hide();
              this.uploading = false;
            }
          );
      }
    }
  }

  RemoveSearch() {
    this.searchValue = "";
  }

  RemoveAll() {
    this.searchTerm = "";
  }

  DownloadFile(file) {
    if (file == "Not Available" || file == null) {
      return;
    } else {
      this.downloading = true;
      this.spinner.show();
      let path = environment.serverIP + "media/";
      let fileName = path + file;
      let downloadFile = fileName;

      let a = document.createElement("a");
      a.setAttribute("href", downloadFile);

      a.click();
      setTimeout(() => {
        this.spinner.hide();
        this.downloading = false;
        a.remove();
      }, 700);
    }
  }

  DownloadSampleFile(file) {
    this.downloading = true;
    let fileName = file.split("/")[1];
    this.spinner.show();
    let a = document.createElement("a");
    a.setAttribute("href", file);
    a.setAttribute("download", fileName);
    a.click();
    setTimeout(() => {
      a.remove();
      this.spinner.hide();
      this.downloading = false;
    }, 700);
  }

  onPageChange(page: number) {
    this.pageControl = page;
  }

  OnDragOver(event) {
    if (event.dataTransfer.items.length > 1) return false;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.isDragged = true;
  }

  onDragLeave(event) {
    this.isDragged = false;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  onDrop(event) {
    if (event.dataTransfer.items.length > 1) return false;
    if (this.files && this.files.length) {
      this.files = [];
      let attachments = this.attachmentForm.get("attachments") as FormArray;
      attachments.removeAt(0);
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    let file: any;
    this.isDragged = false;
    this.fileValid = true;
    if (event.dataTransfer.items) {
      for (let i = 0; i < event.dataTransfer.items.length; i++) {
        if (event.dataTransfer.items[i].kind === "file") {
          file = event.dataTransfer.items[i].getAsFile();
          this.files.push(file);
        }
      }
    }

    this._apiService.readFileData(file).subscribe((response) => {
      if (response.status == "ok") {
        let fb: FormGroup = this.formbuilder.group({
          file: [response.fileObj.data, [Validators.required]],
          actualFile: this.files[0],
          name: [file.name],
          size: file.size,
        });

        let attachments = this.attachmentForm.get("attachments") as FormArray;
        attachments.push(fb);
        this.ValidateFile(attachments.value[0]);
      }
    });
  }

  ValidateFile(file) {
    if (file) {
      let fileSize = Math.ceil(file.size / 1024 / 1024);
      let type = file.name.split(".");
      let fileType = type[type.length - 1];
      if (fileSize > 5) {
        this.fileValid = false;
        this._apiService.fileErrors.getValue().push("File size limit excceds!");
        this._apiService.fileErrors.next(
          this._apiService.fileErrors.getValue()
        );
      } else {
        this.fileValid = true;
      }

      if (fileType.toLowerCase() != "tsv") {
        this.fileValid = false;

        this._apiService.fileErrors.getValue().push("Invalid file type!");
        this._apiService.fileErrors.next(
          this._apiService.fileErrors.getValue()
        );
      } else {
        this.fileValid = true;
      }
    }
  }

  FileSelected() {
    if (this.files && this.files.length) {
      this.files = [];
      let attachments = this.attachmentForm.get("attachments") as FormArray;
      attachments.removeAt(0);
    }
    this.fileValid = true;
    for (let i = 0; i < this.fileInput.nativeElement.files.length; i++) {
      if (this.fileInput.nativeElement.files.length > 0) {
        this.files.push(this.fileInput.nativeElement.files[i]);
      }
    }

    this._apiService.readFileData(this.files[0]).subscribe((response) => {
      if (response.status == "ok") {
        let fb: FormGroup = this.formbuilder.group({
          file: [response.fileObj.data, [Validators.required]],
          actualFile: this.files[0],
          name: [this.fileInput.nativeElement.files[0].name],
          size: this.fileInput.nativeElement.files[0].size,
        });
        let attachments = this.attachmentForm.get("attachments") as FormArray;
        attachments.push(fb);
        this.ValidateFile(attachments.value[0]);
      }
    });
  }

  GetControls(name: string) {
    if (this.files && this.files.length) {
      return (this.attachmentForm.get(name) as FormArray).controls;
    }
  }

  RemoveFile(event) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    this.score = 75;
    this.is_exact = false;
    this.result_count = 1;
    if (this.files && this.files.length) {
      this.files = [];
      this.fileValid = false;
      this._apiService.fileErrors.next([]);
      this.fileInput.nativeElement.value = "";
      let attachments = this.attachmentForm.get("attachments") as FormArray;
      attachments.removeAt(0);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
